var exports = {
  "EY": "Text__MGNUEO",
  "UE": "Text_1__0C16Z6",
  "Nl": "Text_2__a_u35T",
};

module.exports = exports;
